var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("HeaderControls", {
        ref: "refHeaderControls",
        attrs: {
          myWeek: false,
          parentDeliverableId: _vm.parentDeliverableId,
          namespace: _vm.namespace,
          tabTitle: _vm.tabTitle,
          showLogo: _vm.showLogo
        },
        on: {
          filterUpdated: _vm.filterUpdate,
          collapseToggleUpdated: _vm.collapseToggleUpdate,
          showEditDeliverableModal: _vm.showEditDeliverableModal
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "deliverable-main container-fluid" },
        [
          _c(
            "b-modal",
            {
              staticClass: "modal-edit-social-deliverable",
              attrs: {
                size: "lg",
                "no-close-on-backdrop": "",
                "hide-footer": "",
                id: "editSocialModal",
                title: "Edit Related Social Deliverable",
                "no-close-on-esc": ""
              },
              on: {
                show: _vm.editSocialModalShown,
                shown: _vm.afterEditSocialModalShown,
                hide: _vm.editSocialModalHidden
              }
            },
            [
              _c("EditSocialModal", {
                ref: "refEditRelatedSocialModal",
                attrs: {
                  allContacts: _vm.allContacts,
                  tabIndex: _vm.tabIndex,
                  namespace: _vm.namespace,
                  modalId: "editSocialModal"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.systemSettingsReady
            ? _c("SocialScheduleCalendar", {
                ref: "refSocialScheduleCalendar",
                attrs: {
                  myWeek: false,
                  expandAll: _vm.expandAll,
                  namespace: _vm.namespace,
                  parentDeliverableId: _vm.parentDeliverableId
                },
                on: {
                  collapseToggleUpdated: _vm.collapseToggleUpdate,
                  showEditDeliverableModal: _vm.showEditDeliverableModal
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }